/* ---------------------------------------------------------------------------------------------------------------
   ZANTORO – Relaunch-Skripte
   - <zt-nav>: Desktop-Mehrspaltenmenue (Maus, Touch, Tastatur, Escape, Fokus)
   - Geschenkfinder: Gruppe per Anker (#gravur) oeffnen
   - Mobile Kaufleiste: fuehrt zum sichtbaren Pflichtfeld bzw. Kaufbereich (sendet nie selbst ab)
   - Einstieg MEN/WOMEN: optionales, stummes Video (Play/Pause, reduzierte Bewegung)
   - Formularstatus: Fokus auf Erfolg-/Fehlermeldung nach dem Absenden
   Keine Abhaengigkeiten. Mehrfaches Laden (z. B. GemPages-Layout) wird abgefangen.
   Alle Listener werden beim Entfernen (Theme-Editor) wieder abgebaut.
   --------------------------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.__ztRelaunchLoaded) return;
  window.__ztRelaunchLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    var style = window.getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  }

  /* ------------------------------------------------------------------------------------------------------------
     NAVIGATION
     ------------------------------------------------------------------------------------------------------------ */
  if (!window.customElements.get('zt-nav')) {
    class ZtNav extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        this._timers = new Map();
        var signal = this._abort.signal;

        this.querySelectorAll('[data-zt-nav-item]').forEach((item) => {
          var toggle = item.querySelector('[data-zt-nav-toggle]');
          if (!toggle) return;

          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            this.isOpen(item) ? this.close(item) : this.open(item);
          }, { signal: signal });

          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            this._schedule(item, () => this.open(item), 90);
          }, { signal: signal });

          item.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            this._schedule(item, () => this.close(item), 200);
          }, { signal: signal });

          item.addEventListener('focusout', (event) => {
            if (event.relatedTarget && item.contains(event.relatedTarget)) return;
            if (event.relatedTarget === null) return; /* Klick ins Leere uebernimmt der Dokument-Handler */
            this.close(item);
          }, { signal: signal });

          var link = item.querySelector('.zt-nav__link');
          if (link) {
            link.addEventListener('keydown', (event) => {
              if (event.key !== 'ArrowDown') return;
              event.preventDefault();
              this.open(item);
              var first = item.querySelector('[data-zt-nav-panel] a');
              if (first) first.focus();
            }, { signal: signal });
          }
        });

        this.addEventListener('keydown', (event) => this._onKeydown(event), { signal: signal });
        document.addEventListener('click', (event) => this._onDocClick(event), { signal: signal });

        /* Theme-Editor: ausgewaehlten Block oeffnen */
        document.addEventListener('shopify:block:select', (event) => {
          var item = event.target.closest ? event.target.closest('[data-zt-nav-item]') : null;
          if (item && this.contains(item)) this.open(item);
        }, { signal: signal });
        document.addEventListener('shopify:block:deselect', (event) => {
          var item = event.target.closest ? event.target.closest('[data-zt-nav-item]') : null;
          if (item && this.contains(item)) this.close(item);
        }, { signal: signal });
      }

      disconnectedCallback() {
        if (this._abort) this._abort.abort();
        this._abort = null;
        if (this._timers) {
          this._timers.forEach((timer) => clearTimeout(timer));
          this._timers.clear();
        }
      }

      _schedule(item, fn, delay) {
        clearTimeout(this._timers.get(item));
        this._timers.set(item, setTimeout(fn, delay));
      }

      isOpen(item) {
        return item.hasAttribute('open');
      }

      open(item) {
        clearTimeout(this._timers.get(item));
        this.querySelectorAll('[data-zt-nav-item][open]').forEach((other) => {
          if (other !== item) this.close(other);
        });
        var panel = item.querySelector('[data-zt-nav-panel]');
        var toggle = item.querySelector('[data-zt-nav-toggle]');
        if (!panel || !toggle) return;
        panel.hidden = false;
        /* [open] am Menuepunkt: Prestige haelt den Header damit auch ueber transparenten Bereichen deckend */
        item.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }

      close(item, focusToggle) {
        clearTimeout(this._timers.get(item));
        var panel = item.querySelector('[data-zt-nav-panel]');
        var toggle = item.querySelector('[data-zt-nav-toggle]');
        if (!panel || !toggle) return;
        panel.hidden = true;
        item.removeAttribute('open');
        toggle.setAttribute('aria-expanded', 'false');
        if (focusToggle) toggle.focus();
      }

      _onKeydown(event) {
        if (event.key !== 'Escape') return;
        var item = event.target.closest('[data-zt-nav-item]');
        if (item && this.isOpen(item)) {
          event.stopPropagation();
          this.close(item, true);
        }
      }

      _onDocClick(event) {
        if (this.contains(event.target)) return;
        this.querySelectorAll('[data-zt-nav-item][open]').forEach((item) => this.close(item));
      }
    }

    window.customElements.define('zt-nav', ZtNav);
  }

  /* Mobiles Menue schliessen, wenn ein Link angetippt wird (wichtig fuer Sprunglinks auf derselben Seite) */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('#zt-mobile-nav a[href]');
    if (!link) return;
    var drawer = document.getElementById('zt-mobile-nav');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });

  /* ------------------------------------------------------------------------------------------------------------
     GESCHENKFINDER: GRUPPE PER ANKER OEFFNEN (ohne JavaScript funktionieren die Gruppen trotzdem)
     ------------------------------------------------------------------------------------------------------------ */
  function openGiftFromHash(scroll) {
    var raw = (window.location.hash || '').slice(1);
    if (!raw) return;
    var target = document.getElementById(safeDecode(raw));
    if (!target || target.tagName !== 'DETAILS' || !target.closest('[data-zt-gift]')) return;
    target.open = true;
    if (scroll) target.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
  }

  window.addEventListener('hashchange', function () { openGiftFromHash(true); });

  /* ------------------------------------------------------------------------------------------------------------
     MOBILE KAUFLEISTE: ZUM SICHTBAREN PFLICHTFELD / KAUFBEREICH
     Reihenfolge: erstes sichtbares ungueltiges Feld (auch in zugeklappten Bereichen, die dafuer geoeffnet werden)
     → Personalisierung (App-Block / Zusatzfeld) → Variantenauswahl → Kaufbutton.
     Versteckte App-Felder werden nie fokussiert. Das Formular wird nie abgeschickt.
     ------------------------------------------------------------------------------------------------------------ */
  var BUY_TARGETS = [
    '[data-block-type="@app"]',
    '[data-block-type="line-item-property"]',
    '[data-block-type="variant-picker"]',
    '[data-block-type="buy-buttons"]'
  ];

  function formFields(form, scope) {
    var fields = [];
    if (form && form.elements) fields = Array.prototype.slice.call(form.elements);
    if (scope) {
      scope.querySelectorAll('.product-info input, .product-info select, .product-info textarea').forEach(function (el) {
        if (fields.indexOf(el) === -1) fields.push(el);
      });
    }
    return fields;
  }

  function firstVisibleInvalid(form, scope) {
    var fields = formFields(form, scope);
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (el.disabled || el.type === 'hidden' || !el.willValidate || typeof el.checkValidity !== 'function') continue;
      if (el.checkValidity()) continue;

      var closed = el.closest('details:not([open])');
      if (closed && scope && scope.contains(closed)) {
        var summary = closed.querySelector('summary');
        if (summary && isVisible(summary)) closed.open = true;
      }
      if (isVisible(el)) return el;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zt-scroll-to-buy]');
    if (!button) return;
    event.preventDefault();

    var section = document.getElementById('shopify-section-' + button.getAttribute('data-zt-scroll-to-buy'));
    var scope = section || document.body;
    var form = document.getElementById(button.getAttribute('data-zt-form'));
    var invalid = firstVisibleInvalid(form, scope);
    var target = invalid;

    for (var i = 0; i < BUY_TARGETS.length && !target; i++) {
      var candidates = scope.querySelectorAll('.product-info ' + BUY_TARGETS[i]);
      for (var j = 0; j < candidates.length; j++) {
        if (isVisible(candidates[j]) && candidates[j].textContent.trim() !== '') {
          target = candidates[j];
          break;
        }
      }
    }

    if (!target) return;

    target.scrollIntoView({ behavior: scrollBehavior(), block: invalid ? 'center' : 'start' });

    window.setTimeout(function () {
      var focusTarget = invalid;
      if (!focusTarget) {
        focusTarget = target;
        if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
      }
      try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
      if (invalid && typeof invalid.reportValidity === 'function') invalid.reportValidity();
    }, reduceMotion.matches ? 0 : 450);
  });

  /* ------------------------------------------------------------------------------------------------------------
     EINSTIEG: VIDEO
     ------------------------------------------------------------------------------------------------------------ */
  var videoObservers = [];

  function updateToggle(item, playing) {
    var toggle = item.querySelector('[data-zt-video-toggle]');
    if (toggle) toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }

  function setPlaying(item, video, playing) {
    if (!playing) {
      video.pause();
      item.classList.remove('is-playing');
      updateToggle(item, false);
      return;
    }
    var onStarted = function () {
      item.classList.add('is-playing');
      updateToggle(item, true);
    };
    var onFailed = function () {
      item.classList.remove('is-playing');
      updateToggle(item, false);
    };
    var result;
    try {
      result = video.play();
    } catch (e) {
      onFailed();
      return;
    }
    if (result && typeof result.then === 'function') {
      result.then(onStarted, onFailed);
    } else {
      onStarted();
    }
  }

  function initEntryVideos(root) {
    (root || document).querySelectorAll('.zt-entry__item').forEach(function (item) {
      var video = item.querySelector('.zt-entry__video');
      if (!video || item.__ztVideoInit) return;
      item.__ztVideoInit = true;

      var toggle = item.querySelector('[data-zt-video-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var playing = item.classList.contains('is-playing');
          item.__ztUserPaused = playing;
          setPlaying(item, video, !playing);
        });
      }

      if (!video.hasAttribute('data-zt-autoplay') || reduceMotion.matches || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (item.__ztUserPaused) return;
          setPlaying(item, video, entry.isIntersecting);
        });
      }, { threshold: 0.25 });
      observer.observe(item);
      videoObservers.push({ item: item, observer: observer });
    });
  }

  function destroyEntryVideos(root) {
    videoObservers = videoObservers.filter(function (entry) {
      if (root && !root.contains(entry.item)) return true;
      entry.observer.disconnect();
      var video = entry.item.querySelector('.zt-entry__video');
      if (video) video.pause();
      return false;
    });
  }

  /* ------------------------------------------------------------------------------------------------------------
     FORMULARSTATUS
     ------------------------------------------------------------------------------------------------------------ */
  function focusStatus(root) {
    var status = (root || document).querySelector('[data-zt-autofocus]');
    if (!status) return;
    status.scrollIntoView({ block: 'center' });
    try { status.focus({ preventScroll: true }); } catch (e) { status.focus(); }
  }

  function onReady() {
    initEntryVideos();
    focusStatus();
    openGiftFromHash(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEntryVideos(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyEntryVideos(event.target);
  });

  window.addEventListener('pagehide', function (event) {
    if (!event.persisted) destroyEntryVideos(null);
  });
})();
